import { useHttpClient } from "@/common/api/httpClient";
import type { StorageAreaResponse } from "./models/storageAreaResponse";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";
import type { StorageAreaRequest } from "./models/storageAreaRequest";
import { useStorageAreaStore } from "shared/storageAreas/stores/storageAreaStore";

export interface CreateStorageAreaRequest {
  storageArea: StorageAreaRequest;
}

export interface CreateStorageAreaResponse {
  ok: true;
  storageArea: StorageAreaResponse;
}

export function useCreateStorageArea() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const store = useStorageAreaStore();

  return {
    execute
  };

  async function execute(action: CreateStorageAreaRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`storagearea`), {
      headers,
      method: 'POST',
      body: JSON.stringify(action.storageArea)
    });

    const text = translations.value.storageAreas.actions.create;

    const response = await httpClient.action<CreateStorageAreaResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as StorageAreaResponse;
        store.add(json);
        return {
          ok: true,
          storageArea: json
        };
      },
    });

    return response;
  }
}
